<script>
    export let width = "6"; // default width in pixels
    export let height = "16"; // default height in pixels
</script>

<span class="blinking inline-block" style="background-color: currentColor; width: {width}px; height: {height}px;"></span>

